export default __webpack_public_path__ + "static/AseoInd_5-a6d2533ad07a46e67bf8d98320d9f0fe.png";